import { initialListPaginationMeta } from "utils/helpers/pagination";

import {
  ChassisHeightForm,
  ChassisHeightFormDropDownState,
  ChassisHeightState,
} from "../types";

export const initialChassisHeightForm: ChassisHeightForm = {
  manufacturer: "",
  masterModel: "",
  suspensionType: "",
  axleDistance: "",
  tire: "",
  year: "",
  net: "",
  chassisHeightIncludingBody: "",
};

export const initialChassisHeightMeta = initialListPaginationMeta;

export const initialFormDropDownState: ChassisHeightFormDropDownState = {
  items: [],
  page: 1,
  perPage: 20,
  meta: initialChassisHeightMeta,
  loading: false,
};

export const initialState: ChassisHeightState = {
  loading: false,
  saving: false,
  list: [],
  page: 1,
  perPage: 20,
  meta: initialChassisHeightMeta,
  error: null,
  manufacturerFilter: "ALL",
  suspensionTypeFilter: "ALL",
  masterModelFilter: "ALL",
  yearFilter: "2016",
  isAddModalOpen: false,
  form: initialChassisHeightForm,
  formDropDowns: {
    manufacturers: { ...initialFormDropDownState },
    masterModels: { ...initialFormDropDownState },
  },
  detail: null,
  detailLoading: false,
  detailError: null,
};
